import { createSlice } from '@reduxjs/toolkit'

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        role: null
    },
    reducers: {
        login: (state, action) => {
            state.isAuthenticated = true;
            state.role = action.payload.role;
        },
        logout: (state, action) => {
            state.isAuthenticated = false;
            state.role = null;
            localStorage.removeItem("token");
        },
    },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer